<template>
  <div v-if="data != {}">
    <div>
      <div class="progress-link">
        <div class="progress-link-line"></div>
      </div>

      <b-row class="progress-icon-list">
        <b-col cols="4">
          <div class="progress-node">
            <img
              :class="'location-icon ' + is_future_class(data.flowering_date)"
              :src="$config.getAssetsURL('img/main/stage_bud.png')"
              alt="bud icon"
            />
          </div>
        </b-col>
        <b-col cols="4">
          <div class="progress-node">
            <img
              :class="'location-icon ' + is_future_class(data.blooming_date)"
              :src="$config.getAssetsURL('img/main/stage_flower.png')"
              alt="flower icon"
            />
          </div>
        </b-col>
        <b-col cols="4">
          <div class="progress-node">
            <img
              :class="'location-icon ' + is_future_class(data.withering_date)"
              :src="$config.getAssetsURL('img/main/stage_wither.png')"
              alt="wither icon"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row class="mb-3">
      <b-col cols="4">
        <div class="field-stage">{{ $t("menu.stage_flowering") }}</div>
        <div class="field-stage-date">
          {{ $moment(data.flowering_date).format("MM/DD") }}
        </div>
      </b-col>
      <b-col cols="4">
        <div class="field-stage">{{ $t("menu.stage_blossoming") }}</div>
        <div class="field-stage-date">
          {{ $moment(data.blooming_date).format("MM/DD") }}
        </div>
      </b-col>
      <b-col cols="4">
        <div class="field-stage">{{ $t("menu.stage_wither") }}</div>
        <div class="field-stage-date">
          {{ $moment(data.withering_date).format("MM/DD") }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    is_future_class(date) {
      let today = this.$moment(new Date());
      // let _is_future = this.$moment("2022-04-20").isSameOrAfter(date);
      let _is_future = today.isSameOrAfter(date);

      if (_is_future === false) {
        return "future-icon-filter ";
      }

      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.future-icon-filter {
  filter: grayscale(100%);
}

.progress-link {
  position: absolute;
  width: 100%;
  padding: 0px 23% 0px 10%;

  .progress-link-line {
    padding-top: 16%;
    border-bottom: 6px dotted rgb(155, 213, 194);
  }
}
.progress-icon-list {
  position: relative;

  .location-icon {
    width: 100%;
    max-width: 100px;
  }

  .progress-node {
    border: 3px solid rgb(155, 213, 194);
    border-radius: 50%;
    background: white;
  }
}

.field-stage {
  font-size: 0.7rem;
}
.field-stage-date {
  font-weight: 600;
  font-size: 0.9rem;
}
</style>
